import React from 'react';

import { AccountContext } from '../../Context/AccountContext';
import Filter from '../Components/Filter/Filter';
import LoggedOutFilter from '../Components/Filter/LoggedOutFilter';

const FilterContainer: React.FunctionComponent = () => {
    const isLoggedIn = React.useContext(AccountContext).isLoggedIn;

    if (isLoggedIn) {
        return <Filter />;
    } else {
        return <LoggedOutFilter />;
    }
};

export default FilterContainer;
